import React from "react";
import styles from "./about.module.css";

export const About = ({ data }) => {
  return (
    <section id="about" className={styles.aboutSection}>
      <div className={styles.container}>
        <div className={styles.row}>
          {/* Image Column */}
          <div className={styles.column}>
            <img
              src="img/about.jpg"
              alt="About Us"
              className={styles.image}
            />
          </div>

          {/* Text Column */}
          <div className={styles.column}>
            <div className={styles.aboutText}>
              <h2>About Us</h2>
              <p>{data?.paragraph || "Loading..."}</p>

              <h3>Why Choose Us?</h3>
              <div className={styles.listGroup}>
                <div className={styles.listColumn}>
                  <ul>
                    {data?.Why?.map((d, i) => (
                      <li key={`why-${i}`}>{d}</li>
                    )) || "Loading..."}
                  </ul>
                </div>
                <div className={styles.listColumn}>
                  <ul>
                    {data?.Why2?.map((d, i) => (
                      <li key={`why2-${i}`}>{d}</li>
                    )) || "Loading..."}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
